'use strict';

exports.OPEN_FILE = 'OPEN_FILE';
exports.COPY_TO_CLIPBOARD = 'COPY_TO_CLIPBOARD';
exports.DELETE_FILE = 'DELETE_FILE';
exports.UPLOAD = 'UPLOAD';
exports.NEW_FILE = 'NEW_FILE';
exports.SET_APP_ICON = 'SET_APP_ICON';



// WEBPACK FOOTER //
// ./shared/constants.js